import React, { useEffect, useRef } from "react";
import Spinner from "../../components/Spinner";

const BUTTON_BASE =
  "px-3 py-2 rounded w-full sm:w-auto sm:whitespace-nowrap transition-colors";

const CANCEL_STYLE = `${BUTTON_BASE} bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-60 disabled:cursor-not-allowed`;

const CONFIRM_STYLE = `${BUTTON_BASE} bg-[#CBEA7B80] dark:bg-[#A4C639] text-gray-900 dark:text-gray-100 hover:opacity-90 flex items-center justify-center gap-2`;

const Modal = ({
  isVisible,
  message,
  onClose,
  onClick,
  confirmBusy = false,
  cancelLabel = "Cancel",
  confirmLabel = "OK",
  layout = "default",
}) => {
  const cancelButtonRef = useRef(null);
  const isRadicalDelete = layout === "radicalDeleteReport";

  useEffect(() => {
    if (!isVisible || !isRadicalDelete) return;
    cancelButtonRef.current?.focus();
  }, [isVisible, isRadicalDelete]);

  if (!isVisible) return null;

  const cancelButtonClass = isRadicalDelete ? CONFIRM_STYLE : CANCEL_STYLE;
  const confirmButtonClass = isRadicalDelete ? CANCEL_STYLE : CONFIRM_STYLE;

  const cancelButton = (
    <button
      ref={cancelButtonRef}
      type="button"
      className={cancelButtonClass}
      onClick={onClose}
      disabled={confirmBusy}
    >
      {cancelLabel}
    </button>
  );

  const confirmButton = (
    <button
      type="button"
      className={`${confirmButtonClass}${
        confirmBusy ? " opacity-60 cursor-not-allowed" : ""
      }`}
      onClick={onClick}
      disabled={confirmBusy}
    >
      {confirmBusy && <Spinner size={14} color="currentColor" />}
      {confirmLabel}
    </button>
  );

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-[1001]">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 w-full max-w-md mx-4 sm:max-w-xl sm:min-w-[20rem] xl:max-w-md xl:w-1/3">
        {!isRadicalDelete && (
          <h2 className="text-lg font-medium mb-4 text-gray-900 dark:text-gray-200">
            Confirmation
          </h2>
        )}
        <p
          className={`mb-4 text-gray-700 dark:text-gray-200${
            isRadicalDelete ? " font-bold" : ""
          }`}
        >
          {message}
        </p>
        <div className="flex flex-col sm:flex-row sm:flex-nowrap sm:justify-end gap-2">
          {isRadicalDelete ? (
            <>
              {confirmButton}
              {cancelButton}
            </>
          ) : (
            <>
              {cancelButton}
              {confirmButton}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
